import React from "react";
import { useAtom } from "jotai";
import useStore from "../../../context/useStore";
import { AUTH_TYPES } from "../../../context/reducers/authReducers";
import { connectedUserAtom } from "../../../middlewares/AuthMiddleware";
import ImageUtilisateurUploader from "./ImageUtilisateurUploader";
import TamponsManager from "./TamponsManager";
import { fusionnerImagesUtilisateur } from "../../../helpers/imageUtilisateurTools";

/**
 * LS-685 — page self-service (tout utilisateur connecté, sans permission
 * métier) de dépôt de la signature et du tampon, intégrés automatiquement
 * aux documents/emails de financement générés par l'utilisateur.
 *
 * LS-689 — la signature reste unique (apposée telle quelle sur chaque email) ;
 * les tampons sont multiples et nommés, l'utilisateur choisissant lequel
 * apposer au moment de générer l'accord de financement.
 */
const MonCompte = () => {
  const [state, dispatch] = useStore();
  const [, setConnectedUser] = useAtom(connectedUserAtom);
  const user = state.auth.user;

  function updateCurrentUser(updatedUser) {
    // Review sprint20 — les routes images/tampons répondent une UserResource
    // hors route `me` (role en objet, permissions absentes) : on ne fusionne
    // que les champs d'images, le user du store garde sa forme de bootstrap.
    const fusion = fusionnerImagesUtilisateur(user, updatedUser);
    dispatch({ type: AUTH_TYPES.SET_CURRENT_USER, payload: fusion });
    setConnectedUser(fusion);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>Mon compte</h1>
          <p className="text-muted">
            Votre signature est intégrée automatiquement aux emails de
            financement envoyés en votre nom. Vos tampons, eux, sont proposés au
            choix à chaque génération d'accord de financement.
          </p>
          <div className="row">
            <div className="col-md-6">
              <ImageUtilisateurUploader
                type="signature"
                label="Signature"
                imageUrl={user.signatureUrl}
                user={user}
                onChange={updateCurrentUser}
              />
            </div>
            <div className="col-md-6">
              <TamponsManager user={user} onChange={updateCurrentUser} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonCompte;
